import React from 'react'
import { connect } from 'react-redux'
import { useLocation, withRouter } from 'react-router-dom'
import compose from 'recompose/compose'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useIntl } from 'react-intl'
import { history } from '../../../_state/helpers'
import ClassroomSidebar from './Components/ClassroomSidebar'
import CourseStatisticsTabBar, { CourseStatisticsTab } from '../../../Components/CourseStatistics/CourseStatisticsTabBar'
import CourseFindUsersContent from '../../../Components/CourseStatistics/CourseFindUsersContent'
import { i18nMessages } from '../../../Logic/CodeAccessible.i18n.Messages'

const useStyles = makeStyles(() => ({
    root: {
        minHeight: '300px',
        marginLeft: 'calc(15% + 25px)',
        marginRight: '25px',
        paddingBottom: '60px',
    },
    backButton: {
        marginTop: '16px',
        textTransform: 'none',
    },
}))

/**
 * Classroom scoped "find users". Same body as the organization page, scoped to one classroom,
 * which is where teachers have the most use for "who is struggling in this topic".
 */
const ClassroomCourseFindUsers = (props) => {
    const classes = useStyles()
    const intl = useIntl()
    const location = useLocation()

    const { computedMatch, organization, usergroup } = props
    const classroomId = computedMatch?.params?.classroomId

    const searchParams = new URLSearchParams(location.search)
    const initialCourseGroupId = searchParams.get('courseGroupId')
    const initialTopicIdRaw = searchParams.get('topicId')
    const initialTopicId = initialTopicIdRaw ? Number(initialTopicIdRaw) : null

    const classroomName = usergroup?.usergroups?.find((x) => x.id === classroomId)?.name

    const goToCourseStatistics = () => history.push(`/dashboard/classroom/${classroomId}/statistics/courses`)

    return (
        <div className={classes.root}>
            <ClassroomSidebar userGroupId={classroomId} path={computedMatch?.path} />
            <CourseStatisticsTabBar
                activeTab={CourseStatisticsTab.Courses}
                onChange={(tab) => {
                    history.push(
                        tab === CourseStatisticsTab.Overview
                            ? `/dashboard/classroom/${classroomId}/statistics`
                            : `/dashboard/classroom/${classroomId}/statistics/courses`
                    )
                }}
            />

            <Button className={classes.backButton} startIcon={<ArrowBackIcon />} onClick={goToCourseStatistics}>
                {intl.formatMessage(i18nMessages.courseStatisticsBackToCourses)}
            </Button>

            <CourseFindUsersContent
                organizationId={organization.selectedOrganization}
                userGroupId={classroomId}
                initialCourseGroupId={initialCourseGroupId}
                initialTopicId={initialTopicId}
                scopeName={classroomName}
            />
        </div>
    )
}

function mapStateToProps(state) {
    const { organization, user, usergroup } = state
    return {
        organization,
        user,
        usergroup,
    }
}

export default compose(withRouter, connect(mapStateToProps))(ClassroomCourseFindUsers)
